import { t } from '@lingui/core/macro';
import { SalesItemForBookingRecord } from '@navio/nsdk';
import { CarWithSalesItemsForNewBooking, ServiceItemsMappedForFleetWithCars } from 'noddi-types';
import { LanguageCodeType } from 'noddi-util';
import { getPriceFormattedBase } from 'noddi-web';

type LocaleData = {
  label: string;
  flag: string;
};

type SupportedLocalesType = {
  [key in LanguageCodeType]: LocaleData;
};

export const getSupportedLocales = (): SupportedLocalesType => ({
  en: { label: t`English`, flag: '🇬🇧' },
  nb: { label: t`Norwegian`, flag: '🇳🇴' },
  se: { label: t`Swedish`, flag: '🇸🇪' }
});

export const getPriceFormatted = (
  salesItems:
    | CarWithSalesItemsForNewBooking['salesItems']
    | ServiceItemsMappedForFleetWithCars[]
    | SalesItemForBookingRecord[]
) => {
  return getPriceFormattedBase(salesItems, t`from`);
};
